import { useApiMutation } from "./use-api-mutation";

export function useTranslateTemplate() {
  return useApiMutation(
    "post",
    "/shops/{shopId}/email-templates/translate",
    {
      notify: { success: false },
      meta: {
        error: {
          title: "Translation Error",
        },
      },
      mapVariables: ({
        input,
        targetLocales,
        sourceLocale,
        shopId,
      }: {
        input: Record<string, unknown>;
        shopId: string;
        targetLocales: string[];
        sourceLocale: string;
      }) => ({
        params: { path: { shopId } },
        body: {
          input,
          targetLocales,
          sourceLocale,
        },
      }),
    },
  );
}
